import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {NavLink, withRouter} from 'react-router-dom';
import YourRegistryHeaderBase from '../YourRegistryHeaderBase';
import CoupleContext from '../../contexts/CoupleContext';
import UserStateContext from '../../contexts/UserStateContext';
import useSegment from '../../hooks/useSegment';
import useGetWws from '../../hooks/useGetWws';

const WWS_UNINITIALIZED_STATE = 'uninitialized';
const ownedRoutes = /shop|checklist|manage-registry|track-gifts|settings/;
const renderOwnedLink = ({href, ...props}) => (
  <NavLink to={href.split('/registry').pop()} {...props} />
);

const UnwrappedHeader = ({children = null, location}) => {
  const {gvrUrl, wwsUrl} = useContext(CoupleContext);
  const {trackSegmentData} = useSegment();
  const {userStateData} = useContext(UserStateContext);
  const tkrsGCBalance = userStateData.TKRSGiftCards?.totalBalance;
  const {data: wwsStateData} = useGetWws({isEnabled: !wwsUrl});

  const wwsFallbackUrl =
    wwsStateData?.weddingWebsite?.state !== WWS_UNINITIALIZED_STATE
      ? wwsStateData?.weddingWebsite?.wwsUrl
      : null;

  /**
   * Because the DisplayLink in YourRegistryHeaderBase expects an absolute URL,
   * we need to ensure the fallback URL includes the protocol. We default to https
   * since wws should always be secure.
   */
  const wwsFallbackUrlHttps =
    wwsFallbackUrl && !wwsFallbackUrl.startsWith('https://')
      ? `https://${wwsFallbackUrl}`
      : wwsFallbackUrl;

  const onNavigate = ({selection}) =>
    trackSegmentData({eventName: 'Menu Interaction', eventData: {selection}});

  const onClickGuestViewUrl = ({source}) =>
    trackSegmentData({eventName: 'Clicked View as Guest', eventData: {source}});

  const guestViewUrl = wwsUrl || wwsFallbackUrlHttps || gvrUrl;

  // Checklist stays reachable by URL but has no tab.
  const routes = [
    {routeName: 'Shop'},
    {
      routeName: 'Manage Registry',
      children: <span>Manage</span>,
    },
    {routeName: 'Track Gifts'},
    {routeName: 'Settings'},
  ];

  return (
    <YourRegistryHeaderBase
      guestViewUrl={guestViewUrl || ''}
      location={location}
      onNavigate={onNavigate}
      onClickGuestViewUrl={onClickGuestViewUrl}
      ownedRoutes={ownedRoutes}
      renderOwnedLink={renderOwnedLink}
      routes={routes}
      storeCreditBalance={userStateData.storeCredit}
      tkrsGCBalance={tkrsGCBalance}>
      {children}
    </YourRegistryHeaderBase>
  );
};

UnwrappedHeader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default withRouter(UnwrappedHeader);
